// extracted by mini-css-extract-plugin
export const offices = "q_Y";
export const offices_wrap = "q_0";
export const offices_tabs = "q_1";
export const offices_link = "q_2";